
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $cd42fcf7bc2a5142$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"37GuQ\",\"index.4c23f5eb.js\",\"hApQ7\",\"boc_mac_cho_con.da063f62.jpg\",\"kRIni\",\"nang-luong-goc.604fff50.jpg\",\"2jBCq\",\"pp-voi-chinh-minh.70065b74.jpg\",\"e146P\",\"giai-phong-con-tuc-gian.76950c23.jpg\",\"hqVvz\",\"modeling.44861445.jpg\",\"eIuMm\",\"niem-tin-gioi-han.1bc5812f.jpg\"]"));

var $1bf763d22d31b915$exports = {};
$1bf763d22d31b915$exports = new URL("nang-luong-goc.604fff50.jpg", import.meta.url).toString();


var $f3381016f9acc6ff$exports = {};
$f3381016f9acc6ff$exports = new URL("pp-voi-chinh-minh.70065b74.jpg", import.meta.url).toString();


var $1fbaa959e075addf$exports = {};
$1fbaa959e075addf$exports = new URL("boc_mac_cho_con.da063f62.jpg", import.meta.url).toString();


var $22d06fa7ac54f769$exports = {};
$22d06fa7ac54f769$exports = new URL("giai-phong-con-tuc-gian.76950c23.jpg", import.meta.url).toString();


var $f81e5515902ac7dc$exports = {};
$f81e5515902ac7dc$exports = new URL("modeling.44861445.jpg", import.meta.url).toString();


var $3d8b982dc70e3ec8$exports = {};
$3d8b982dc70e3ec8$exports = new URL("niem-tin-gioi-han.1bc5812f.jpg", import.meta.url).toString();


const $ade342ca4d253c6c$var$listEvent = document.querySelectorAll(".item-benefit");
const $ade342ca4d253c6c$var$imgEvent = document.getElementById("image_event");
const $ade342ca4d253c6c$var$imageSources = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1bf763d22d31b915$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f3381016f9acc6ff$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1fbaa959e075addf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($22d06fa7ac54f769$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f81e5515902ac7dc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3d8b982dc70e3ec8$exports)))
];
$ade342ca4d253c6c$var$listEvent.forEach((item, index)=>{
    item.addEventListener("mouseenter", ()=>{
        if ($ade342ca4d253c6c$var$imgEvent && $ade342ca4d253c6c$var$imageSources[index]) $ade342ca4d253c6c$var$imgEvent.src = $ade342ca4d253c6c$var$imageSources[index];
    });
});


//# sourceMappingURL=index.4c23f5eb.js.map
